import * as React from 'react';
import { Badge } from "primereact/badge";
import { GroupServiceGetManyResponse, GroupServiceGetResponse } from "../../services/api";
import { GroupStatus } from '../../utils/types';

type AnyGroup = GroupServiceGetResponse | GroupServiceGetManyResponse;

export default function GroupBadges({ group }: { group: AnyGroup }) {
  const statusType = React.useMemo(() => {
    switch (group.requestStatus) {
      case GroupStatus.COMPLETED:
        return {
          label: 'Complete',
          severity: 'info',
        }
      case GroupStatus.RERATE_ALL:
      case GroupStatus.RERATE_REQUESTED:
      case GroupStatus.RERATE_COMPLETED:
        return {
          label: 'Rerate',
          severity: 'contrast',
        }
      case GroupStatus.HIGH_RISK:
      case GroupStatus.HIGH_RISK_REQUESTED:
        return {
          label: 'High risk',
          severity: 'danger'
        }
      case GroupStatus.TIER2_APPROVED:
      case GroupStatus.TIER2_REQUESTED:
      case GroupStatus.TIER2_DECLINED:
      case GroupStatus.TIER2_COMPLETED:
        return {
          label: 'Tier 2',
          severity: null,
        }
      default:
        return null;
    }
  }, [group.requestStatus]);

  const statusProgress = React.useMemo(() => {
    switch (group.requestStatus) {
      case GroupStatus.TIER2_DECLINED:
        return {
          label: 'Declined',
          severity: 'declined',
        }
      case GroupStatus.RERATE_REQUESTED:
      case GroupStatus.TIER2_REQUESTED:
      case GroupStatus.HIGH_RISK_REQUESTED:
        return {
          label: 'Requested',
          severity: 'pending',
        }
      case GroupStatus.RERATE_COMPLETED:
      case GroupStatus.TIER2_COMPLETED:
      case GroupStatus.TIER2_APPROVED:
        return {
          label: 'Approved',
          severity: 'approved',
        }
      default: 
        return null;
    }
  }, [group.requestStatus]);

  return (
      <div className="flex gap-2 empty:hidden">
        {!statusType && group.policyDetailModel && group.policyDetailModel?.eligibleRateRelief && (
          <Badge severity="success" value="Eligible for rate relief" />
        )}
        
        {statusType && (
          <>
            <Badge severity={statusType.severity} value={`${statusType.label}`} />
            {statusProgress && (
              <Badge severity={statusProgress.severity} value={statusProgress.label} />
            )}
          </>
        )}
      </div>
  );
}